import { render, staticRenderFns } from "./ApprovePaymentPage.vue?vue&type=template&id=1d752b5f&scoped=true"
import script from "./ApprovePaymentPage.vue?vue&type=script&lang=js"
export * from "./ApprovePaymentPage.vue?vue&type=script&lang=js"
import style0 from "./ApprovePaymentPage.vue?vue&type=style&index=0&id=1d752b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d752b5f",
  null
  
)

export default component.exports